import React from 'react';

import { useFieldActions } from '../../../../contexts/field-actions-context';
import { FieldPropsContext } from '../../../../contexts/field-props-context';
import { useForm } from '../../../../contexts/form-context';
import { type FieldLayoutComponent } from '../../../../field-layout';
import { useSubmitButton } from '../../../../fields/submit-button/submit-button/use-submit-button';
import { useExternalData } from '../../contexts/external-data-context';
import { useFormFields } from '../../contexts/form-fields-context';
import { type SubmitButtonField as SubmitButtonFieldEntity } from '../../types';

export interface SubmitButtonFieldProps {
  field: SubmitButtonFieldEntity;
  FieldLayout: FieldLayoutComponent;
}

export const SubmitButtonField = ({
  field,
  FieldLayout,
}: SubmitButtonFieldProps) => {
  const { submitText, nextText, previousText, text } = field.properties as any;

  const componentsById = useFormFields();
  const externalData = useExternalData();
  const form = useForm();
  const { actions } = useFieldActions();
  const {
    handleSubmitClick,
    isDisabled,
    isInProgress,
    showPreviousButton,
    showNextButton,
    showSubmitButton,
    hasSteps,
  } = useSubmitButton({
    form,
    id: field.id,
  });

  const submitButtonText: string = submitText || text || '';
  const previousButtonText: string = previousText || '';
  const nextButtonText: string = nextText || '';
  const FieldComponent = componentsById[field.fieldType];

  if (!FieldComponent) {
    return null;
  }

  const fieldProps = {
    ...field.properties,
    id: field.id,
    externalData,
    fieldType: field.fieldType,
    FieldLayout,
    hasSteps,
    isDisabled,
    isInProgress,
    showPreviousButton,
    showNextButton,
    showSubmitButton,
    submitText: submitButtonText,
    previousText: previousButtonText,
    nextText: nextButtonText,
    onSubmitClick: handleSubmitClick,
    onPreviousClick: () => actions?.setPreviousStep(),
    onNextClick: () => actions?.setNextStep(),
  };

  return (
    <FieldPropsContext.Provider value={{ v2: fieldProps }}>
      <FieldComponent {...fieldProps} />
    </FieldPropsContext.Provider>
  );
};
